/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Button from '@material-ui/core/Button'
import { CircularProgress } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  button: {
    width: '100%',
    // borderRadius: '50px',
    color: 'white',
    fontWeight: '600',
    textTransform: 'none',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      // padding: '0px 178px',
      // paddingTop: '10px',
      // paddingBottom: '10px',
      width: '90%',
    },
  },
  secondaryButton: {
    backgroundColor: theme.palette.secondary.main,

    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  outlined: {
    color: theme.palette.secondary.main,
    border: '1px solid #32499F',
    width: '150px',
    display: 'flex',
    margin: '0px auto',
    '&:hover': {
      background: 'none',
      border: '1px solid #32499F',
    },
  },
  goButton: {
    width: '45px',
    fontSize: '16px',
    marginLeft: '20px',
  },
  detail: {
    width: '86px',
    fontSize: '14px',
    marginLeft: '0px',
    textTransform: 'none',
  },
  noWidth: {
    width: 'auto',
    marginLeft: '20px',
  },
  // detail
}))

export default ({ text, className, handleSubmit, disabled, color, outlined, icon, noWidth }) => {
  const classes = useStyles()
  const renderClass = className ? `${className} ${classes.button}` : noWidth ? `${className} ${classes.noWidth}` : classes.button
  return (
    <Button
      disabled={disabled}
      variant={outlined ? 'outlined' : 'contained'}
      color={color ? color : 'primary'}
      className={renderClass}
      onClick={handleSubmit}
      startIcon={icon}
      fullWidth={noWidth ? false : true}
    >
      {text}
    </Button>
  )
}
